(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    const drawer = document.getElementById('filters-drawer');
  if (drawer) {
    const toggle = document.querySelector('.facets-toggle__button[aria-controls="filters-drawer"]');
    if (toggle) {
      drawer.addEventListener('dialog:open', () => toggle.setAttribute('aria-expanded', 'true'));
      drawer.addEventListener('dialog:close', () => toggle.setAttribute('aria-expanded', 'false'));
    }
  }
  } catch(e) { console.error(e); }
})();

})();
